"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = useHovered;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = require("react");

function useHovered(_ref) {
  var hovered = _ref.hovered,
      onMouseEnter = _ref.onMouseEnter,
      onMouseLeave = _ref.onMouseLeave,
      onMouseMove = _ref.onMouseMove;

  var _useState = (0, _react.useState)(false),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      hoveredState = _useState2[0],
      setHoveredState = _useState2[1];

  var handleMouseEnter = (0, _react.useCallback)(function (evt) {
    if (onMouseEnter) onMouseEnter(evt);
    setHoveredState(true);
  }, [onMouseEnter]);
  var handleMouseLeave = (0, _react.useCallback)(function (evt) {
    if (onMouseLeave) onMouseLeave(evt);
    setHoveredState(false);
  }, [onMouseLeave]); // Why listen for `mousemove`? See: https://git.hubteam.com/HubSpot/UIComponents/issues/3927

  var handleMouseMove = (0, _react.useCallback)(function (evt) {
    if (onMouseMove) onMouseMove(evt);
    setHoveredState(true);
  }, [onMouseMove]);
  return {
    hovered: hovered != null ? hovered : hoveredState,
    onMouseEnter: hoveredState ? onMouseEnter : handleMouseEnter,
    onMouseLeave: hoveredState ? handleMouseLeave : onMouseLeave,
    onMouseMove: hoveredState ? onMouseMove : handleMouseMove
  };
}

module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.3773/js/hooks/useHovered.js
// module id = 201
// module chunks = 0